import * as e from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Eye.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "EyeIcon";
const n = o;
export {
  n as Eye,
  o as EyeIcon
};
